import React, { useState } from 'react'
import { createContext } from "react";


export const PodcastAllOptionsContext = createContext()
function PodcastAllOptionsContextProvider({ children }) {
  const [podcastId, setPodcastId] = useState(null)
  const [singlePodcastId, setSinglePodcastId] = useState(null);
  return (
    <PodcastAllOptionsContext.Provider value={{ podcastId, setPodcastId, singlePodcastId, setSinglePodcastId }} >
      {children}
    </PodcastAllOptionsContext.Provider>

  )
}

export default PodcastAllOptionsContextProvider